import { dateFormat, getAge } from "helpers/common";
import moment from "moment";
import { Col, Row } from "react-bootstrap";
import date_img from "../../../Assets/images/date.png"
import { useFormikContext } from "formik";
import { useParams } from "react-router-dom";

const ClientDetails = ({ showDOB, heading, data, clientType }) => {
  const formik = useFormikContext()
  const { assessmentId } = useParams()
  
  return (
    <>
      <h5 className="section-title">{heading}</h5>
      <div className="mb-3 d-flex align-items-center" style={{ gap: "20px" }}>
        <div style={{ width: "25%" }}>
          <label className="discharge-screen-label">Last Name</label>
          <input className="readonly-box" readOnly value={data?.lastname} />
        </div>
        <div style={{ width: "25%" }}>
          <label className="discharge-screen-label">First Name</label>
          <input className="readonly-box" readOnly value={data?.firstname} />
        </div>
        <div style={{ width: !showDOB ? "30%" : "50%" }}>
          <label className="discharge-screen-label">City/Town</label>
          <input className="readonly-box" readOnly value={data?.client_detail?.city_town} />
        </div>
        {!showDOB && <div style={{ width: "20%" }}>
          <label className="discharge-screen-label">Date of Report</label>
          <div className="readonly-box d-flex align-items-center">
            <input className="border-0 w-100" readOnly value={assessmentId == 10 ? formik?.values?.screening_date : moment().format("YYYY-MM-DD")} />
            <img width={14} height={16} src={date_img} alt="date_img" />
          </div>
        </div>}
      </div>
      <div className="mb-4 d-flex align-items-center" style={{ gap: "20px" }}>
        <div style={{ width: "25%" }}>
        </div>
        <div style={{ width: "25%" }}>
        </div>
        <div style={{ width: "20%" }}>
          <label className="discharge-screen-label">Birth Date</label>
          <div className="readonly-box d-flex align-items-center">
            <input className="border-0 w-100" readOnly value={dateFormat(data?.client_detail?.dob)} />
            <img width={14} height={16} src={date_img} alt="date_img" />
          </div>
        </div>
        <div style={{ width: "15%" }}>
          <label className="discharge-screen-label">Age</label>
          <div className="mt-2">{getAge(data?.client_detail?.dob)}</div>
        </div>
        {!["chatter"].includes(clientType) && (
          <div style={{ width: "10%" }}>
            <label className="discharge-screen-label">Grade</label>
            <input className="readonly-box" readOnly value={data?.client_detail?.grade} />
          </div>
        )}
      </div>
    </>
  )
}

export default ClientDetails;